import React, { useEffect, useLayoutEffect, useState } from "react";
import { useStore } from "react-redux";
import { useMedia } from "use-media";
import { useHistory } from "react-router-dom";

import right_arrow from "../../resources_catalog/icons/ico_right_arrow.svg";
import icon_pdf from "../../resources_catalog/icons/ico_pdf.svg";
import catalog_title_img from "../../resources_catalog/images/catalog_title_img.svg";
import logo_terc from "../../resources_catalog/images/logo_terc.png";
import aboutServicePdf from "../../resources_catalog/pdf/RTCCサービス新旧対照表.pdf"
import { Link } from "react-router-dom";

// 国内ホテル
import jp_hotel_img01 from "../../resources_catalog/images/hotel_japan/hotel_img_jp_11.jpg";
import jp_hotel_img02 from "../../resources_catalog/images/hotel_japan/hotel_img_jp_12.jpg";
import jp_hotel_img03 from "../../resources_catalog/images/hotel_japan/hotel_img_jp_15.jpg";
import jp_hotel_img04 from "../../resources_catalog/images/hotel_japan/hotel_img_jp_05.jpg";
import jp_hotel_img05 from "../../resources_catalog/images/hotel_japan/hotel_img_jp_10.jpg";

// 海外ホテル
import oversea_hotel_img01 from "../../resources_catalog/images/hotel_hawaii/hotel_img_hi_26.jpg";
import oversea_hotel_img02 from "../../resources_catalog/images/hotel_hawaii/hotel_img_hi_06.jpg";
import oversea_hotel_img03 from "../../resources_catalog/images/hotel_hawaii/hotel_img_hi_24.jpg";
import oversea_hotel_img04 from "../../resources_catalog/images/hotel_hawaii/hotel_img_hi_03.jpg";
import oversea_hotel_img05 from "../../resources_catalog/images/hotel_hawaii/hotel_img_hi_23.jpg";

import catalog_point_img01 from "../../resources_catalog/images/catalog_point_img01.svg";
import catalog_point_img02 from "../../resources_catalog/images/catalog_point_img02.svg";
import catalog_point_img03 from "../../resources_catalog/images/catalog_point_img03.svg";
import catalog_point_img04 from "../../resources_catalog/images/catalog_point_img04.svg";
import { useRtoaster } from "../../hooks/useRtoaster";



export const CatalogAboutServiceContainer = (props) => {
  const isWidePhone = useMedia({ maxWidth: "480px" });
  const isWideTablet = useMedia({ maxWidth: "960px" });
  const history = useHistory();
  const [linkList, setLinkList] = useState([]);
  const onClickBack = () => {
    history.push(props.path);
  }

  const store = useStore();
  // レスポンス設定リスト
  const [isHeightOver1, setIsHeightOver1] = useState(false);
  const [isHeightOver2, setIsHeightOver2] = useState(false);
  const [isHeightOver3, setIsHeightOver3] = useState(false);
  const [isHeightOver4, setIsHeightOver4] = useState(false);
  const [isHeightOver5, setIsHeightOver5] = useState(false);
  const [isHeightOver6, setIsHeightOver6] = useState(false);
  const [isHeightOver7, setIsHeightOver7] = useState(false);
  const [isHeightOver8, setIsHeightOver8] = useState(false);
  const [isHeightOver9, setIsHeightOver9] = useState(false);
  const [isHeightOver10, setIsHeightOver10] = useState(false);

  // rtoasterタグ生成
  useRtoaster();

  //この関数は画面レンダリング前に動きます
  useLayoutEffect(() => {
  })

  //この関数は画面レンダリング後に動きます
  useEffect(() => {
    setLinkList([{ path: "/rtcc/catalog/home", label: "ホーム" }]);
    const scrollAction = () => {
      if (300 < window.scrollY) {
        setIsHeightOver1(true);
      }
      if(700 < window.scrollY){
        setIsHeightOver2(true);
      }
      if(1200 < window.scrollY){
        setIsHeightOver3(true);
      }
      if(1500 < window.scrollY){
        setIsHeightOver4(true);
      }
      if(1800 < window.scrollY){
        setIsHeightOver5(true);
      }
      if(2400 < window.scrollY){
        setIsHeightOver6(true);
      }
      if(3100 < window.scrollY){
        setIsHeightOver7(true);
      }
      if(3300 < window.scrollY){
        setIsHeightOver8(true);
      }
      if(3500 < window.scrollY){
        setIsHeightOver9(true);
      }
      if(3800 < window.scrollY){
        setIsHeightOver10(true);
      }
    };
    window.addEventListener("scroll", scrollAction, {
      capture: false,
      passive: true,
    });
  }, []);

  // homeへ
  const onClickHome = () => {
    history.push("/rtcc/catalog/home");
  }
  // 国内ホテルラインナップへ
  const onClickHotelLineupJp = () => {
    history.push("/rtcc/catalog/hotelLineupJp");
  }
  // 海外ホテルラインナップへ
  const onClickHotelLineupOverseas = () => {
    history.push("/rtcc/catalog/hotelLineupOverseas");
  }
  const onClickPdfLink = () => {
    document.getElementById("aboutServicePdf").click();
  }

  return (
    <div className="catalogContentWrap">
      <div className="catalogContent">
        <div className="catlogBackBlock"></div>
        <div className="catalogContentsBlock">
          <div className="catalogContentsTitle">
            <img src={catalog_title_img} alt="" className="catalogContentsTitleImg" />
            <p>RTCC旅行業サービスとは</p>
            <p className="catalogContentsTitleCaption">ABOUT</p>
          </div>
          <div className="catalogContentsAboutService">
            <div className="catalogContentsAboutServiceInner">
              <p className="catalogContentsAboutServiceCaptionText">
                厳選された国内外のリゾート施設をご紹介し、ご利用をサポートするサービスです。 長年変わらずご愛顧いただきました海外・国内ご宿泊サービスの 「RTCC交換プログラム（海外・国内）」は 世界情勢の変化や会員の皆様のニーズの多様化にお応えするため 様々なご要望を取り入れて2022年4月1日から、会員様の利便性をよりいっそう高める 新サービスに生まれ変わりました。
              </p>
              <div className="catalogContentsAboutServicePlanJp">
                <div className="catalogContentsAboutServicePlan">
                  <div className="catalogContentsAboutServicePlanInner">
                    <div className="catalogAboutServicePlanImgWrap01">
                      <div id="planJpImg01" className={"catalogAboutServicePlanJpImg01 js_trigger " + (isHeightOver1 ? "isHeightOver" : "")}>
                        <img src={jp_hotel_img01} alt="" />
                      </div>
                      <div className={"catalogAboutServicePlanJpImg02 js_trigger " + (isHeightOver1 ? "isHeightOver" : "")}>
                        <img src={jp_hotel_img02} alt="" />
                      </div>
                    </div>
                    <div className="catalogAboutServicePlanImgWrap02">
                      <div className={"catalogAboutServicePlanJpImg03  js_trigger " + (isHeightOver2 ? "isHeightOver" : "")}>
                        <img src={jp_hotel_img03} alt="" />
                      </div>
                      <div className="catalogAboutServicePlanJpText">
                        <p className="catalogAboutServicePlanJpTextTitle">RTCC宿泊{isWideTablet ? <br /> : " "}ホテルラインナップ</p>
                        <p className="catalogAboutServicePlanJpTextSubTitle">【国内・海外手配旅行】</p>
                        <p className="catalogAboutServicePlanJpTextCaption">四季折々に移り変わる風情を満喫することは、日本国内を旅する醍醐味といえます。旬の味覚に舌鼓を打ち、きめ細やかな心遣いに胸を打たれる。慌ただしく過ぎていく日々を離れ、緩やかな時の流れに身を委ねてください。</p>
                        <div className="catalogContentsButton" onClick={onClickHotelLineupJp}>
                          <p>RTCC宿泊 ホテルラインナップへ</p>
                          <img src={right_arrow} alt="" />
                        </div>
                      </div>
                    </div>
                    <div className="catalogAboutServicePlanImgWrap03">
                      <div className={"catalogAboutServicePlanJpImg04 js_trigger " + (isHeightOver3 ? "isHeightOver" : "")}>
                        <img src={jp_hotel_img04} alt="" />
                      </div>
                      <div className={"catalogAboutServicePlanJpImg05 js_trigger " + (isHeightOver3 ? "isHeightOver" : "")}>
                        <img src={jp_hotel_img05} alt="" />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="catalogContentsAboutServicePlanOversea">
                <div className="catalogContentsAboutServicePlan">
                  <div className="catalogContentsAboutServicePlanInner">
                    <div className="catalogAboutServicePlanImgWrap01">
                      <div className={"catalogAboutServicePlanOverseaImg01 js_trigger " + (isHeightOver4 ? "isHeightOver" : "")}>
                        <img src={oversea_hotel_img01} alt="" />
                      </div>
                      <div className={"catalogAboutServicePlanOverseaImg02 js_trigger " + (isHeightOver4 ? "isHeightOver" : "")}>
                        <img src={oversea_hotel_img02} alt="" />
                      </div>
                    </div>
                    <div className="catalogAboutServicePlanImgWrap02">
                      <div className={"catalogAboutServicePlanOverseaImg03 js_trigger " + (isHeightOver5 ? "isHeightOver" : "")}>
                        <img src={oversea_hotel_img03} alt="" />
                      </div>
                      <div className="catalogAboutServicePlanOverseaText">
                        <p className="catalogAboutServicePlanOverseaTextTitle">RTCCハワイ{isWideTablet ? <br /> : " "}ホテルラインナップ</p>
                        <p className="catalogAboutServicePlanOverseaTextSubTitle">【海外募集型企画旅行】</p>
                        <p className="catalogAboutServicePlanOverseaTextCaption">世界中の人々で賑わいをみせるハワイ諸島の宿泊施設をラインナップ。大切な人と二人でゆったりと過ごしたり、家族みんなで和気あいあいと楽しむなど、あらゆる想いやこだわりにお応えします。</p>
                        <div className="catalogContentsButton" onClick={onClickHotelLineupOverseas}>
                          <p>RTCCハワイ ホテルラインナップへ</p>
                          <img src={right_arrow} alt="" />
                        </div>
                      </div>

                    </div>
                    <div className="catalogAboutServicePlanImgWrap03">
                      <div className={"catalogAboutServicePlanOverseaImg04 js_trigger " + (isHeightOver6 ? "isHeightOver" : "")}>
                        <img src={oversea_hotel_img04} alt="" />
                      </div>
                      <div className={"catalogAboutServicePlanOverseaImg05 js_trigger " + (isHeightOver6 ? "isHeightOver" : "")}>
                        <img src={oversea_hotel_img05} alt="" />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="catalogContentsTitle">
                <img src={catalog_title_img} alt="" className="catalogContentsTitleImg" />
                <p>新サービス4つのポイント</p>
              </div>
              <div className="catalogContentsAboutService">
                <div className="catalogContentsAboutServiceInner">
                  <div className="catalogContentsAboutServicePlanListWrap">
                    <div className="catalogContentsAboutServicePlanList">
                      <div className={"catalogContentsAboutServicePlanListImg01 js_trigger " + (isHeightOver7 ? "isHeightOver" : "")}></div>
                      <div className="catalogContentsAboutServicePlanListText">
                        <div className="catalogContentsAboutServicePlanListPoint" >
                          <img src={catalog_point_img01} alt="" className="catalogContentsAboutServicePlanListPointImg" />
                          <div className="catalogContentsAboutServicePlanListCaptionTitle">
                            会員制ならではのプレミアムな体験をご提案
                          </div>
                        </div>
                        <p className="catalogContentsAboutServicePlanListCaptionText">
                          一律の宿泊手数料負担から、その都度の宿泊室料負担でのご提供に変わり、国内外ともにお部屋のグレードのラインアップを大幅に拡大した宿泊施設をご用意しています。旅の目的に合わせて最適なお部屋や施設を選ぶことができ、プレミアムな宿泊プランなどもご用意しています。
                        </p>
                      </div>
                    </div>
                    <div className="catalogContentsAboutServicePlanList">
                      <div className={"catalogContentsAboutServicePlanListImg02 js_trigger " + (isHeightOver8 ? "isHeightOver" : "")}></div>
                      <div className="catalogContentsAboutServicePlanListText">
                        <div className="catalogContentsAboutServicePlanListPoint" >
                          <img src={catalog_point_img02} alt="" className="catalogContentsAboutServicePlanListPointImg" />
                          <div className="catalogContentsAboutServicePlanListCaptionTitle">
                            安心の現地サポートが充実
                          </div>
                        </div>
                        <p className="catalogContentsAboutServicePlanListCaptionText">
                          提携現地旅行会社によるサポートで、海外ご滞在中も安心してお過ごしいただけます。ハワイホノルルでは、JALPAKアロハステーションがご利用可能です。ハワイスペシャリスト上級検定を取得しているコンシェルジュが、観光情報をはじめとする滞在中の様々なニーズにお応えします。
                        </p>
                      </div>
                    </div>
                    <div className="catalogContentsAboutServicePlanList">
                      <div className={"catalogContentsAboutServicePlanListImg03 js_trigger " + (isHeightOver9 ? "isHeightOver" : "")}></div>
                      <div className="catalogContentsAboutServicePlanListText">
                        <div className="catalogContentsAboutServicePlanListPoint" >
                          <img src={catalog_point_img03} alt="" className="catalogContentsAboutServicePlanListPointImg" />
                          <div className="catalogContentsAboutServicePlanListCaptionTitle">
                            宿泊権利の消化は不要、予約は350日前から受付<br />（一部商品を除く）
                          </div>
                        </div>
                        <p className="catalogContentsAboutServicePlanListCaptionText">
                          宿泊占有日や宿泊権利は不要のため、権利消化を気にすることなくご利用になれます。また、予約開始日が350日前から（一部商品除く）となりますので、旅の計画が立てやすくなります。
                        </p>
                      </div>
                    </div>
                    <div className="catalogContentsAboutServicePlanList">
                      <div className={"catalogContentsAboutServicePlanListImg04 js_trigger " + (isHeightOver10 ? "isHeightOver" : "")}></div>
                      <div className="catalogContentsAboutServicePlanListText">
                        <div className="catalogContentsAboutServicePlanListPoint" >
                          <img src={catalog_point_img04} alt="" className="catalogContentsAboutServicePlanListPointImg" />
                          <div className="catalogContentsAboutServicePlanListCaptionTitle">
                            ご予約・ご決済はスマホやPCで簡単に
                          </div>
                        </div>
                        <p className="catalogContentsAboutServicePlanListCaptionText">
                          24時間365日対応で、スマートフォンの「RTTGアプリ」　やWEBサイトで空室検索、ご予約、クレジットカードでのオンライン決済をスムーズに行うことができ、即日回答も実現。パソコン操作が苦手な方にはRTCCスタッフがサポートいたします。
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="catalogContentsTitle">
                <img src={catalog_title_img} alt="" className="catalogContentsTitleImg" />
                <p>サービスについて</p>
              </div>
              <div className="catalogContentsAboutServiceButtonWrap">
                <div className="catalogContentsButtonPdf" onClick={onClickPdfLink}>
                  <img src={icon_pdf} alt="" />
                  <p><a id="aboutServicePdf" href={aboutServicePdf} target="_blank" rel="noopener noreferrer" >サービス内容新旧対照表</a></p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* <div className="ly_service_terc">
        <div className="_inner">
          <div className="bl_service_terc">
            <div className="bl_service_terc_img"><img src={logo_terc} alt="THE EDEN RESIDENCE CLUB" /></div>
            <div className="bl_service_terc_textArea">
              <p className="_title">海外クラブサービス</p>
              <p className="_text">海外クラブサービスとしてスコットランドが本拠地の「エデン・レジデンス・クラブ」と提携いたしました。この提携により通常、提携クラブの会員本人でなければ使うことのできない海外の高級別荘等をご利用になれます。<br></br>具体的なご利用条件やご利用方法につきましては、準備が整い次第ホームページにてお知らせいたします。</p>
            </div>
          </div>
        </div>
      </div> */}
      <div className={isWideTablet ? "none" : "catalogBreadCrumb"}>
          {linkList.map((value, index) => (
            <div key={"link" + index} style={{ display: "flex" }}>
              <Link to={value.path} className="link">{value.label}</Link>
              <div className="lastLabel">&gt;</div>
            </div>
          ))}
          <div className="lastLabel">RTCC旅行業サービスとは</div>
        </div>
    </div>
  );
};
